<div
  [ngClass]="{ active: show }"
  class="businessProfileSelectorScreen__content"
>
  <p class="businessProfileSelectorScreen__content-title">
    {{ pageData.title }}
  </p>

  <!-- Company List -->
  <div
    class="businessProfileSelectorScreen__content--company"
    *ngFor="
      let company of pageData.businessProfile;
      let i = index;
      let first = first;
      let last = last
    "
  >
    <!-- Company Header -->
    <div
      (click)="
        isBusinessOnlyPath(company.permissionTypes)
          ? noExpand({
              companyName: company.companyName,
              permType: company.permissionTypes,
              accountIndex: i,
              corporateId: company.corporateId,
              displayInlineText: company.displayInlineText,
              isOaSmeAccount: company.isOaSmeAccount,
              partnerId: company.partnerId,
              restrictOnePax: company.restrictOnePax,
              disableMiles: company.disableMiles
            })
          : expand(i)
      "
      [ngClass]="{
        selected:
          businessStateSelected.selectedState &&
          businessStateSelected.accountIndex === i,
        first: first,
        last: last,
        'only-business': isBusinessOnlyPath(company.permissionTypes)
      }"
      class="businessProfileSelectorScreen__content--company-name"
    >
      <idp-accordion
        [type]="'secondary'"
        [viewLabel]="company.displayName"
        [hideLabel]="company.displayName"
        [caretType]="'secondary'"
        [modalTitle]="
          businessStateSelected.selectedState &&
          businessStateSelected.accountIndex === i
            ? company.displayName + ' Selected'
            : company.displayName
        "
        [state]="i === permissionDiv && show"
        [targetContent]="'businessProfile_' + i"
        [id]="'businessProfileBtn_' + i"
      ></idp-accordion>

      <span
        class="business-check-mark"
        [ngClass]="{
          selected:
            businessStateSelected.selectedState &&
            businessStateSelected.accountIndex === i,
          'only-business': isBusinessOnlyPath(company.permissionTypes)
        }"
      ></span>
    </div>

    <!-- Permission Types -->
    <a
      class="businessProfileSelectorScreen__content--permission"
      [ngClass]="{
        active: show,
        details: i === permissionDiv && show
      }"
      *ngFor="let permissionCompany of company.permissionTypes"
      [id]="'businessProfile_' + i"
      href="javascript:void(0)"
      (click)="
        onClick({
          companyName: company.companyName,
          permType: permissionCompany.permType,
          accountIndex: i,
          corporateId: company.corporateId,
          displayInlineText: company.displayInlineText,
          isOaSmeAccount: company.isOaSmeAccount,
          partnerId: company.partnerId,
          restrictOnePax: company.restrictOnePax,
          disableMiles: company.disableMiles
        })
      "
    >
      <div>
        <p class="businessProfileSelectorScreen__content--permission-title">
          {{ permissionCompany.title }}
        </p>
        <div
          class="businessProfileSelectorScreen__content--permission-description"
        >
          <p>{{ permissionCompany.description }}</p>
          <div class="type-list-arrow"></div>
        </div>
        <div
          *ngIf="show"
          [ngClass]="{ first: first, last: last }"
          class="businessProfileSelectorScreen__content--permission-divider"
        ></div>
      </div>
    </a>
  </div>
</div>
